import { makeStyles } from '@material-ui/core/styles'
import { getOutlinedTextFieldWrapperStyles } from 'lib/form-field-styles'

export const useRequirementCardStyles = makeStyles(theme => ({
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}))

export const useRequirementDialogStyles = makeStyles(theme => ({
  paper: {
    maxHeight: '90vh',
  },
  legalDoc: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.6,
    color: '#172024',
    '& > *': {
      color: '#172024 !important',
      font: 'unset',
      fontFamily: 'inherit',
      fontSize: 'inherit',
      lineHeight: 'inherit',
    },
    '& h2, & h3, & h5': {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 700,
      lineHeight: 1.3,
      color: '#00205B',
    },
    '& h2': {
      fontSize: '0.9375rem',
      margin: '0 0 16px',
    },
    '& h3, & h5': {
      fontSize: '0.9375rem',
      margin: '24px 0 12px',
    },
    '& p': {
      margin: '0 0 16px',
    },
    '& ul, & ol': {
      margin: '8px 0 16px',
      paddingLeft: theme.spacing(3),
    },
    '& li': {
      marginBottom: theme.spacing(1.5),
    },
    '& li:last-child': {
      marginBottom: 0,
    },
    '& a': {
      color: '#0053FF',
    },
  },
  bodyCopy: {
    margin: 0,
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: '#172024',
  },
  bodyCopyEmphasis: {
    margin: '16px 0 0',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.5,
    color: '#172024',
  },
  formContent: {
    '&.MuiDialogContent-root': {
      padding: theme.spacing(2, 3),
    },
  },
  formFields: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  formField: {
    margin: 0,
    minWidth: 0,
    ...getOutlinedTextFieldWrapperStyles(theme),
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(12px, 0) scale(0.75)',
      backgroundColor: theme.palette.common.white,
      padding: '0 4px',
    },
  },
  formFieldFull: {
    gridColumn: '1 / -1',
  },
  pillButton: {
    minWidth: 0,
    width: 'auto',
    flex: '0 0 auto',
    borderRadius: 20,
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '0.9375rem',
    padding: theme.spacing(1, 2),
    boxShadow: 'none',
    '& .MuiButton-startIcon': {
      marginLeft: 0,
      marginRight: theme.spacing(0.75),
    },
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 83, 255, 0.28)',
    },
  },
}))

export const useRequirementChipStyles = makeStyles({
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    borderRadius: 9999,
    padding: '2px 8px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.02em',
    whiteSpace: 'nowrap',
    boxShadow: 'none',
  },
})
